const refundPolicyEN = {
	title: "Refund Policy",
	lastUpdated: "Effective Date",

	intro: {
		p1: `{{COMPANY_NAME}} (“we,” “our,” or “us”) provides an online platform that connects clients with barbers, salons, and other service providers. This Refund Policy explains the circumstances under which refunds may be issued for fees paid to Sin Fila.`,
	},

	platformFees: {
		heading: "1. Platform Fees",
		p1: "All payments collected by Sin Fila are for platform use by businesses (monthly subscription fees or other platform fees).",
		p2: "Sin Fila does not process payments between clients and service providers, so this Refund Policy does not apply to client payments for booked services.",
	},

	eligibility: {
		heading: "2. Refund Eligibility",
		list: [
			"Refunds for platform fees may be considered only if a payment was charged in error (duplicate charge, incorrect amount, or other billing mistake).",
			"All other refund requests are evaluated on a case-by-case basis and approved at the sole discretion of Sin Fila.",
		],
	},

	midMonth: {
		heading: "3. Mid-Month Cancellations & Staff Changes",
		p1: "If a business cancels its monthly subscription, access to the Services will continue until the end of the current billing period, and no refunds will be issued for unused days.",
		p2: "Exception – Staff Removal:",
		p3: "If a barber or business removes a staff member mid-month, the fee for that staff member will be pro-rated based on the remaining days in the billing period.",
		p4: "Pro-rated adjustments will be applied automatically to the next billing cycle or refunded at Sin Fila’s discretion.",
	},

	process: {
		heading: "4. Refund Process",
		p1: "To request a refund for a billing error, contact us at {{CONTACT_EMAIL}} within 30 days of the original payment.",
		p2: "Include: business name and account email, date and amount of payment, and reason for the refund request.",
		p3: "Approved refunds will be processed back to the original payment method. Processing times may vary depending on banks or payment providers.",
	},

	nonRefundable: {
		heading: "5. Non-Refundable Situations",
		list: [
			"Fees for platform use already provided (full month access), even if canceled mid-month, except for staff removal pro-rated adjustments.",
			"Technical issues with bookings caused by third-party service providers, internet connectivity, or user error.",
			"Temporary outages or unavailability of the Services, except in extraordinary cases at Sin Fila’s sole discretion.",
			"Losses or damages claimed by clients or businesses as a result of using the platform.",
		],
	},

	changes: {
		heading: "6. Changes to Refund Policy",
		text: "We may update this Refund Policy at any time. Updated versions will be posted on the website and app. Continued use of the Services constitutes acceptance of the updated Policy.",
	},

	contact: {
		heading: "7. Contact Us",
		text: "For questions about this Refund Policy or to submit a request, email {{CONTACT_EMAIL}}.",
	},
};

export default refundPolicyEN;
